module.exports = __webpack_public_path__ + "static/media/cp14.3eb695d4.pdf";